import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { getCookie } from "typescript-cookie";
import { useAddOwnershipTypesMutation, useDeleteOwnershipTypesMutation, useEditOwnershipTypesMutation } from "../../../../../redux/api/handBooksApi/ownershipTypesApi";  // Updated API imports
import { EntDirectoryInfoName } from "../../../../../models/directoryInfoName";


const useOwnershipTypes = (modal: any, refresh?: () => void) => {  // Updated hook name
    const { t } = useTranslation();
    const { confirm } = modal;
    const [addOwnershipTypes] = useAddOwnershipTypesMutation();  // Updated mutation names
    const [deleteOwnershipTypes] = useDeleteOwnershipTypesMutation();  // Updated mutation names
    const [editOwnershipTypes] = useEditOwnershipTypesMutation();  // Updated mutation names

    async function onAddOwnershipTypes(newOwnershipTypes: EntDirectoryInfoName): Promise<boolean> {  // Updated function name
        try {
            let status: boolean = false;
            await addOwnershipTypes(newOwnershipTypes).then((response: any) => {  // Updated function name
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }

    async function onDeleteOwnershipTypes(ownershipTypes: EntDirectoryInfoName) {  // Updated function name
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t("general.no"),
                onOk() {
                    deleteOwnershipTypes(ownershipTypes.id as number).then((response: any) => {  // Updated function name
                        if (response.error !== undefined && response.error.status === 400) {
                            status = false;
                            throw new Error(response.error.data.message);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    async function onEditOwnershipTypes(editedOwnershipTypes: EntDirectoryInfoName): Promise<boolean> {  // Updated function name
        try {
            let status: boolean = false;
            await editOwnershipTypes(editedOwnershipTypes).then((response: any) => {  // Updated function name
                if (response.error !== undefined && response.error.status === 400) {
                    throw new Error(response.error.data.message);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    return { onAddOwnershipTypes, onDeleteOwnershipTypes, onEditOwnershipTypes };  // Updated return values
}

export { useOwnershipTypes };  // Updated export
